export const FOOD_PRODUCT = 'fi-bakery flaticon-023-croissant';
export const DISH = 'fi-meal flaticon-012-soup';
export const DRINK = 'fi-coffee-shop flaticon-034-milkshake';
export const MEAL = 'fi-meal flaticon-008-chicken-1';

export const MALE = 'icon-ca-user-male';
export const FEMALE = 'icon-ca-user-female';
export const GENDERLESS = 'far fa-genderless';
export const INSTANCE_ADMIN = 'fas fa-user-cog';
export const INSTANCE_OWNER = 'fas fa-user-tie';
export const SUPER_USER = 'fas fa-user-ninja';

export const SYMBOL_MALE = 'fas fa-mars';
export const SYMBOL_FEMALE = 'fas fa-venus';
export const SYMBOL_GENDERLESS = 'fas fa-genderless';



// WEBPACK FOOTER //
// ./src/constants/icons.js